<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<form [formGroup]="formRelatorios" #ProgramacaoFerias="ngForm">
  <div class="card shadow">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <a href="/home" class="text-dark mr-2">
          <i class="fa fa-arrow-left"></i>
        </a>
        <span>Gerador de Relatórios</span>
      </h3>
    </div>
    <div class="card-body">
      <ul class="nav nav-fill nav-tabs">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" data-target="#executar" href="#">
            <i class="fa fa-tasks"></i>
            <span> Criar Tarefa</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" data-target="#acompanhar" href="#">
            <i class="fa fa-eye"></i>
            <span> Acompanhar</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" data-target="#historico" href="#">
            <i class="fa fa-history"></i>
            <span> Histórico</span>
          </a>
        </li>
      </ul>
      <div class="tab-content p-2">
        <div class="tab-pane fade show active" id="executar">
          <div class="row">
            <div class="col-md-3 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                maxlength="7"
                mask="00/0000"
                class="form-control shadow-sm"
                name="competencia"
                placeholder="MM/AAAA"
              />
            </div>
            <div class="col-md-4 form-group">
              <label class="font-weight-semibold">Tipo de Processamento</label>
              <select class="form-control shadow-sm" name="tpproc">
                <option value="">Selecione...</option>
                <option value="EM">EM - FOLHA FECHAMENTO MENSAL</option>
              </select>
            </div>
            <div class="col-md-5 form-group">
              <label class="font-weight-semibold">Tipo de Execução</label>
              <select
                class="form-control shadow-sm"
                formControlName="tipoExecucao"
                [ngClass]="{
                  'is-invalid':
                    formRelatorios.get('tipoExecucao').invalid &&
                    formRelatorios.get('tipoExecucao').touched
                }"
                (change)="onTipoExecucaoChange()"
              >
                <option value="">Selecione...</option>
                <option *ngFor="let item of listaExecucao" [value]="item.Codigo">
                  {{ item.Codigo }} - {{ item.Descricao }}
                </option>
              </select>
            </div>

            <div class="col-md-12 form-group table-responsive">
              <table class="table table-striped table-hover">
                <thead class="bg-teal-400">
                  <tr>
                    <th>Cód. Programa</th>
                    <th>Tipo Proc.</th>
                    <th>Descrição</th>
                    <th class="text-right" style="padding-right: 100px">Parâmetros/Seleção</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let relatorio of parametosRelatorios">
                    <td>{{ relatorio.CodigoPrograma }}</td>
                    <td>{{ relatorio.TipoPrograma }}</td>
                    <td>{{ relatorio.Conteudo }}</td>
                    <td
                      class="d-flex align-items-center justify-content-center"
                      style="gap: 10px; white-space: nowrap"
                    >
                      <button
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        data-target="#modal-parametros"
                        (click)="abrirParametros(relatorio)"
                      >
                        <span>Parâmetros </span>
                        <i class="fa fa-plug"></i>
                      </button>

                      <button class="btn btn-outline-success btn-sm">
                        <span>Adicionar </span>
                        <i class="fa fa-plus-circle"></i>
                      </button>
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      parametosRelatorios.length === 0 && formRelatorios.get('tipoExecucao').valid
                    "
                  >
                    <td colspan="4" class="text-center">Nenhum parâmetro encontrado</td>
                  </tr>
                  <tr *ngIf="formRelatorios.get('tipoExecucao').invalid">
                    <td colspan="4" class="text-center">Selecione um Tipo de Execução</td>
                  </tr>
                </tbody>

                <tr>
                  <td colspan="4" class="text-center">
                    <button type="button" class="btn btn-success btn-block btn-lg shadow-sm">
                      <span>Iniciar Programas Selecionados </span>
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="acompanhar">
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="font-weight-semibold d-flex justify-content-between">
                <span>Últimas 10 tarefas</span>
                <span class="text-muted">* para Situação "Executando"</span>
              </label>
              <select class="form-control shadow-sm" name="tpproc">
                <option value="x">03107IGF I - 02/2025-EM-RM (FPVB03/S1, FPVBCAL/S1) *</option>
                <option value="x">03107IGF I - 02/2025-EM-RM (FPVB03/S1, FPVBCAL/S1) *</option>
                <option value="x">03107IGF I - 02/2025-EM-RM (FPVB03/S1, FPVBCAL/S1)</option>
                <option value="x">03107IGF I - 02/2025-EM-RM (FPVB03/S1, FPVBCAL/S1)</option>
              </select>
            </div>
            <div class="col-md-12 form-group table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Programa</th>
                    <th width="250">Situação</th>
                    <th>Aqruivos</th>
                    <th class="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>FP055</td>
                    <td class="bg-warning">
                      <i class="spinner-border spinner-border-sm"></i>
                      <span>Executando...</span>
                    </td>
                    <td>FP055.html</td>
                    <td class="text-right">
                      <div class="btn-group shadow-sm">
                        <button class="btn btn-outline-success btn-sm">
                          <span>Baixar</span>
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>FP019</td>
                    <td class="bg-success">
                      <i class="fa fa-check"></i>
                      <span>Finalizado!</span>
                    </td>
                    <td>FP019.pdf</td>
                    <td class="text-right">
                      <div class="btn-group shadow-sm">
                        <button class="btn btn-outline-success btn-sm">
                          <span>Baixar</span>
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>FP055</td>
                    <td class="bg-info">
                      <i class="fa fa-clock-o"></i>
                      <span>Em Aberto...</span>
                    </td>
                    <td></td>
                    <td class="text-right">
                      <div class="btn-group shadow-sm">
                        <button class="btn btn-outline-success btn-sm" disabled>
                          <span>Baixar</span>
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>FPVB033</td>
                    <td class="bg-danger">
                      <i class="fa fa-exclamation-triangle"></i>
                      <strong>Cancelado:</strong>
                      <span>Texto da falha se houver!</span>
                    </td>
                    <td></td>
                    <td class="text-right">
                      <div class="btn-group shadow-sm">
                        <button class="btn btn-outline-success btn-sm" disabled>
                          <span>Baixar</span>
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-end">
                        <div>
                          <button
                            type="button"
                            class="btn btn-danger btn-lg mr-2"
                            data-toggle="modal"
                            data-target="#modal-confirma-parar"
                          >
                            <span>Parar execução </span>
                            <i class="fa fa-hand-paper-o"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary btn-lg"
                            data-toggle="modal"
                            data-target="#modal-confirma-exclusao"
                          >
                            <span>Excluir todos </span>
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="historico">
          <div class="row">
            <div class="col-md-2 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                maxlength="7"
                mask="00/0000"
                class="form-control shadow-sm"
                name="competencia"
                placeholder="MM/AAAA"
              />
            </div>
            <div class="col-md-4 form-group">
              <label class="font-weight-semibold">Tipo de Processamento</label>
              <select class="form-control shadow-sm" name="tpproc">
                <option value="">Selecione...</option>
                <option value="EM">EM - FOLHA FECHAMENTO MENSAL</option>
              </select>
            </div>
            <div class="col-md-5 form-group">
              <label class="font-weight-semibold">Tipo de Execução</label>
              <select class="form-control shadow-sm" name="tipoexec">
                <option value="">Selecione...</option>
                <option *ngFor="let item of listaExecucao" [value]="item.Codigo">
                  {{ item.Codigo }} - {{ item.Descricao }}
                </option>
              </select>
            </div>
            <div class="col-md-1 form-group">
              <label>&nbsp;</label>
              <button type="button" class="btn btn-primary btn-block">
                <i class="fa fa-search"></i>
              </button>
            </div>
            <div class="col-12 table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Cód. Tarefa</th>
                    <th>Competência</th>
                    <th>Tipo de Processamento</th>
                    <th>Tipo de Execução</th>
                    <th class="text-center">Em execução?</th>
                    <th class="text-center">Acompanhar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-success">Sim</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-secondary">Não</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-secondary">Não</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-success">Sim</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-success">Sim</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-secondary">Não</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-secondary">Não</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-secondary">Não</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>15366498</td>
                    <td>02/2025</td>
                    <td>S1 - Suplementar 1</td>
                    <td>RM Mensal</td>
                    <td class="text-center">
                      <span class="badge badge-pill badge-success">Sim</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <footer>
                  <tr>
                    <td colspan="4" class="text-center"></td>
                  </tr>
                </footer>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer"></div>
  </div>
</form>

<div
  class="modal fade"
  id="modal-parametros"
  tabindex="-1"
  [ngClass]="{ 'd-none': escondidoTemporariamente }"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-muted">
          <i class="fa fa-plug"></i>
          <span> Parâmetros do programa {{ relatorioSelecionado?.CodigoPrograma }}</span>
        </h5>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Dados dos parâmetros a serem alterados:</p>
        <div class="table-responsive">
          <table class="table table-striped">
            <tbody>
              <tr *ngFor="let campo of detalhesParametros">
                <th class="text-right">{{ campo.DescricaoCampo }}</th>
                <td
                  class="d-flex align-items-center justify-content-center"
                  style="gap: 10px; white-space: nowrap"
                >
                  <textarea
                    placeholder="Conteúdo do parâmetro"
                    class="form-control"
                    [(ngModel)]="campo.Conteudo"
                    readonly
                  ></textarea>
                  <button
                    (click)="abrirCriticaModal(campo)"
                    data-toggle="modal"
                    data-target="#modal-critica"
                    class="btn btn-outline-info d-flex btn-sm mt-2"
                  >
                    <span>Editar </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          <span>Fechar sem alterar </span>
          <i class="fa fa-close"></i>
        </button>
        <button type="button" class="btn btn-success" data-dismiss="modal">
          <span>Altarar parâmetros </span>
          <i class="fa fa-save"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="modal-confirma-parar" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-danger">
          <i class="fa fa-hand-paper-o"></i>
          <span>Paralização de Tarefa!</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="lead">
          Confirma a paralização das tarefas? Após a confirmação a tarefa não poderá mais ser
          reiniciada!
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
          <span>Desistir</span>
          <i class="fa fa-close"></i>
        </button>
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          <span>Confirmar</span>
          <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modal-critica"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Editar Parâmetros</h5>
        <button type="button" class="close" (click)="fecharSemSalvar()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <table class="table">
          <tbody>
            <ng-container *ngFor="let campocrit of dadosCritica">
              <tr *ngIf="campocrit.Protegido !== 'S'">
                <th class="text-right align-middle">{{ campocrit.DescricaoCampo }}</th>
                <td>
                  <div class="row">
                    <div class="col-md-12">
                      <label>Conteúdo</label>
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="campocrit.Formato"
                        (ngModelChange)="validarCampo(campocrit)"
                        (keypress)="filtrarInput($event, campocrit.TipoCampo)"
                        [maxlength]="campocrit.Tamanho"
                        [disabled]="campocrit.Protegido === 'S'"
                      />
                      <small class="text-muted">
                        Tipo: {{ campocrit.TipoCampo }} | Tamanho máximo: {{ campocrit.Tamanho }}
                      </small>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="fecharSemSalvar($event)">
          <span>Fechar </span>
          <i class="fa fa-close"></i>
        </button>
        <button type="button" class="btn btn-success" (click)="salvarEFechar($event)">
          <span>Salvar </span>
          <i class="fa fa-save"></i>
        </button>
      </div>
    </div>
  </div>
</div>
